import { handleHr }  from "./quill-hr";

export default {
	CDNroot: "https://cdnjs.cloudflare.com/ajax/libs/quill",
	version: "1.3.6",
	toolbar: {
		icons: {
			hr: '<span class="icon-before" data-icon="minus"></span>',
			pdf: '<span class="icon-before" data-icon="acrobat"></span>',
			office: '<span class="icon-before" data-icon="ms-office"></span>',
			undo: '<span class="icon-before" data-icon="undo"></span>',
			redo: '<span class="icon-before" data-icon="redo"></span>'
		},
		
		titles: {
			"color": "文字色",
			"background": "背景色",
			"bold": "太字",
			"italic": "斜体",
			"underline": "下線",
			"strike": "取り消し線",
			"script": {
				"sub": "下付き",
				"super": "上付き"
			},
			"list": {
				"bullet": "箇条書き",
				"ordered": "段落番号"
			},
			"indent": {
				"-1": "インデントを減らす",
				"+1": "インデントを増やす"
			},
			"align": "文字揃え",
			"blockquote": "引用",
			"code-block": "コードブロック",
			"hr": "罫線",
			"link": "リンク",
			"pdf": "PDF",
			"office": "MSオフィス",
			"image": "画像",
			"video": "動画の埋め込み",
			"clean": "書式をクリア",
			"undo": "元に戻す",
			"redo": "やり直す"
		},
		
		handlers: {
			hr() {
				handleHr(this.quill);
			},
			pdf() {
				this.quill.vuwField.get("pdfUploader").$inpFile.trigger("click", [true]);
			},
			office() {
				this.quill.vuwField.get("officeUploader").$inpFile.trigger("click", [true]);
			},
			image() {
				this.quill.vuwField.get("imageUploader").$inpFile.trigger("click", [true]);
			},
			undo() {
				this.quill.history.undo();
			},
			redo() {
				this.quill.history.redo();
			}
		}
	}
};
